import { useEffect } from "react";

const SEO_SECTIONS = {
  hero: {
    title: "Royal Horizon Mobility Ltd | Travel Agency & Jobs Abroad — Nairobi, Kenya",
    description:
      "Professional travel agency in Nairobi. Air ticketing, visa assistance, gulf jobs, pay while working in Europe, and Canada visa applications.",
  },
  about: {
    title: "About Us | Royal Horizon Mobility Ltd — Nairobi",
    description:
      "Royal Horizon Mobility Ltd is a trusted travel and global mobility company based in Nairobi. Integrity, excellence, and reliability in every journey.",
  },
  services: {
    title: "Our Services | Air Ticketing, Visa, Tours — Royal Horizon Mobility",
    description:
      "Air ticketing, hotel reservations, visa assistance, travel insurance, airport transfers, corporate travel, honeymoon packages — all from Nairobi, Kenya.",
  },
  "careers-abroad": {
    title: "Jobs Abroad | Gulf Jobs, Europe & Canada Visa — Royal Horizon Mobility",
    description:
      "Find overseas jobs in Ireland, Norway, Netherlands, and Gulf countries. Canada visa application assistance. Royal Horizon Mobility Ltd, Nairobi.",
  },
  contact: {
    title: "Contact Us | Royal Horizon Mobility Ltd — Nairobi",
    description:
      "Visit us at Nanak House, Kimathi Street, 4th Floor, Room 407, Nairobi. Call or email Royal Horizon Mobility Ltd for travel and job placement inquiries.",
  },
};

export default function SEO() {
  useEffect(() => {
    const sections = Object.keys(SEO_SECTIONS);

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            const id  = entry.target.id;
            const seo = SEO_SECTIONS[id];
            if (!seo) return;

            // Update title
            document.title = seo.title;

            // Update meta description
            let desc = document.querySelector('meta[name="description"]');
            if (desc) desc.setAttribute("content", seo.description);

            // Update OG
            let ogTitle = document.querySelector('meta[property="og:title"]');
            if (ogTitle) ogTitle.setAttribute("content", seo.title);

            let ogDesc = document.querySelector('meta[property="og:description"]');
            if (ogDesc) ogDesc.setAttribute("content", seo.description);
          }
        });
      },
      { threshold: 0.4 }
    );

    sections.forEach((id) => {
      const el = document.getElementById(id);
      if (el) observer.observe(el);
    });

    return () => observer.disconnect();
  }, []);

  return null;
}
